import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "hd" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "more",
    href: "/loveflower"
  }, [
    /*#__PURE__*/_createTextVNode(" 更多爱情鲜花 "),
    /*#__PURE__*/_createElementVNode("span", { class: "icon icon-arrow-right" })
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "/loveflower" }, "爱情鲜花"),
    /*#__PURE__*/_createElementVNode("span", null, "送 · 让你怦然心动的人")
  ])
], -1)
const _hoisted_3 = { class: "fl-products" }
const _hoisted_4 = { class: "img-box" }
const _hoisted_5 = { class: "product-content" }
const _hoisted_6 = { class: "product-title" }
const _hoisted_7 = { class: "product-price" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "price-sign" }, "¥", -1)
const _hoisted_9 = { class: "price-num" }

import { getFlowers } from '../http/index'
import { ref, onMounted } from 'vue'
 
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeContent',
  setup(__props) {

const router = useRouter();
const list = ref();
// const props = defineProps({
//   image: String,
//   type: Number,
// })
onMounted(async () => {
    let parms = {
        Id: 0,
        Type: 1
    } 
    list.value = (await getFlowers(parms)).data.result
})

const GoToDetail = (currId: Number) => {
  const sss = ref()
  sss.value = currId;
  router.push({ path: '/detail', query: { id: sss.value, type:1 } });
}

return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { width: "300px" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  style: {"margin-top":"20px"},
                  src: "/images/content/home_floor_lover.png"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "fl-products-item",
                      key: item
                    }, [
                      _createElementVNode("a", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_el_link, {
                            onClick: ($event: any) => (GoToDetail(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_image, {
                                style: {"width":"220px","height":"240px"},
                                src: item.image
                              }, null, 8, ["src"])
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
                          _createElementVNode("p", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.price), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})